// src/components/Layout.js

import React, { useState, useEffect, useContext } from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import FilterHeader from './FilterHeader';
// import FilterHeaderPro from './FilterHeaderPro';  ← Eliminado, lo gestiona ProPetsPage
import { ScrollProvider } from '../context/ScrollContext';
import { TabContext } from '../context/TabContext';

export default function Layout() {
  const [showFilterHeader, setShowFilterHeader] = useState(false);
  const { activeTab, setActiveTab } = useContext(TabContext);

  // Alterna visibilidad del header de filtros
  const toggleFilterHeader = () => {
    setShowFilterHeader(prev => {
      const next = !prev;
      return next;
    });
  };

  useEffect(() => {
    //console.log('[Layout] showFilterHeader is now', showFilterHeader);
  }, [showFilterHeader]);

  const hideFilterHeader = () => {
    setShowFilterHeader(false);
  };

  // Solo mostramos el FilterHeader (usuario normal) en la pestaña 'home'
  const isHomeFilter = activeTab === 'home';

  return (
    <ScrollProvider>
      <div>
        {/* Header recibe el toggle para mostrar/ocultar el filtro */}
        <Header
          forceVisible={showFilterHeader}
          toggleFilterHeader={toggleFilterHeader}
        />

        {/* En Home, renderizamos el header de filtros */}
        {showFilterHeader && isHomeFilter && (
          <FilterHeader onHide={hideFilterHeader} />
        )}

        {/* Ajustamos padding-top cuando se muestra el filtro */}
        <div
          style={{
            paddingTop: showFilterHeader && isHomeFilter ? '85px' : '0px'
          }}
        >
          {/*
            Pasamos showFilterHeader, toggleFilterHeader y hideFilterHeader
            para que ProPetsPage pueda gestionar su propio FilterHeaderPro.
          */}
          <Outlet
            context={{
              activeTab,
              setActiveTab,
              showFilterHeader,
              toggleFilterHeader,
              hideFilterHeader
            }}
          />
        </div>

        <Footer toggleFilterHeader={toggleFilterHeader} />
      </div>
    </ScrollProvider>
  );
}
